import { orderBy } from 'lodash/fp';
import { Field, InjectedFormProps, reduxForm } from 'redux-form';
import styled from 'styled-components';

import InputField from 'dashboard/components/FormControls/InputField';
import ReactSelectField from 'dashboard/components/FormControls/ReactSelectField';
import { Role } from 'dashboard/models/role';
import Button from 'design-system/components/Button';
import { EMAIL_ADDRESS_REGEX } from 'lib/constants/regexes';
import FormControlField from 'lib/interfaces/FormControlField';
import { isRequired, matchesRegexp, withMessage } from 'lib/utils/formValidation';

const SaveButton = styled(Button)`
  width: 30%;
  min-width: 190px;
`;

const validate = {
  emailAddress: [
    withMessage('Please enter a new email address', isRequired),
    withMessage('The email you entered is not valid', matchesRegexp(EMAIL_ADDRESS_REGEX)),
  ],
  role: [withMessage('Please select a role', isRequired)],
};

interface FormNewUserProps {
  roles: Role[];
}

const FormNewUser = ({
  handleSubmit,
  submitting,
  pristine,
  roles,
}: FormNewUserProps & InjectedFormProps<{}, FormNewUserProps>) => {
  const UserValues = orderBy(['attributes.name'], ['asc'], roles).map((role: Role) => ({
    label: role.attributes.name,
    value: role.id,
  }));

  return (
    <form onSubmit={handleSubmit}>
      <FormControlField
        component={ReactSelectField}
        name='roleIds'
        id='form-new-user__role'
        data-test='form-new-user__role'
        disabled={submitting}
        isSearchable={true}
        label="Start by selecting member's role"
        portal={true}
        options={UserValues}
        validate={validate.role}
        isMulti
      />

      <Field
        component={InputField}
        label='Email'
        name='emailAddress'
        id='emailAddress'
        type='email'
        data-test='form-new-user__email-address'
        validate={validate.emailAddress}
        disabled={submitting}
        disclaimer='Persona highly discourages email addresses from free domains such as Gmail due to access to sensitive information.'
        disclaimerType='banner'
        placeholder='teammember@example.com'
      />

      <SaveButton
        type='submit'
        data-test='form-new-user__submit'
        disabled={submitting || pristine}
        isPending={submitting}
      >
        Send invitation
      </SaveButton>
    </form>
  );
};

export const formName = 'newUser';

export interface FormNewUserData {
  roleIds: string;
  emailAddress: string;
}

export default reduxForm<FormNewUserData, FormNewUserProps>({
  form: formName,
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
})(FormNewUser);
